export const LIST_TITLE = {
  text: 'The process takes 5 minutes and has 3 steps:',
  className: 'text-style-g-em text-neutral-700 mb-4',
  skeletonProps: {
    width: 280,
  },
};

export const LIST = {
  etika: {
    list: {
      items: [
        "Read and agree Ideal4Finance's T&C's (1 minute)",
        "Complete Ideal4Finance's application form (2 minutes)",
        'Create your Etika account and submit your loan application (2 minutes)',
      ],
    },
  },
  introduction: {
    list: {
      items: [
        "Read and agree Ideal4Finance's T&C's (1 minute)",
        'Review your previously entered information and submit your application (2 minutes)',
        'Await a decision from the lender (2 minutes)',
      ],
    },
  },
  default: {
    list: {
      items: [
        "Read and agree Ideal4Finance's T&C's (1 minute)",
        "Complete Ideal4Finance's application form (2 minutes)",
        'Await a decision from the lender (2 minutes)',
      ],
    },
  },
};

export const HEADER_CLASS_NAMES = {
  container: 'flex w-full flex-col mb-6',
  descriptionWrapper: 'flex flex-1 w-full flex-row items-center',
  title: 'block text-style-e text-neutral-900 mb-4',
  description: 'w-full text-14-22 text-neutral-700 mr-6',
  bold: 'text-14-22-em',
  icon: 'flex-none',
};

export const HEADER_PROPS = {
  title: {
    text: 'Welcome! Start your application for finance with {{provider}}, via Ideal4Finance. It only takes a few minutes.',
    className: HEADER_CLASS_NAMES.title,
    skeletonProps: {
      count: 2,
    },
  },
  etikaTitle: {
    text: 'Welcome! Start your application to Etika finance, via Ideal4Finance.',
    className: HEADER_CLASS_NAMES.title,
    skeletonProps: {
      count: 2,
    },
  },
  introductionTitle: {
    text: "Welcome! Let's get you approved for finance for the order. It only takes a minute.",
    className: HEADER_CLASS_NAMES.title,
    skeletonProps: {
      count: 2,
    },
  },
  description: {
    textLine1:
      'Ideal4Finance is a credit broker and loans are provided through ',
    textLine2: ". You're applying for credit for your purchase from ",
    textLine3:
      'Ideal4Finance will help you complete your application, and will be with you every step of the way, so you are in good hands.',
    otherProps: {
      skeletonProps: {
        count: 4,
      },
    },
  },
  icon: {
    size: 48,
    icon: 'shield-check',
    stroke: 'purple-200',
    className: HEADER_CLASS_NAMES.icon,
  },
};

export const PROVIDERS = {
  omni: 'Omni Capital Retail Finance, part of Castle Trust Bank',
  allium: 'Tandem Bank',
  propensio: 'Propensio Finance Limited',
  etika: 'Etika Finance UK Limited',
  humm: 'Humm Group Limited',
  demo: 'Ideal4Finance',
};
